export default __webpack_public_path__ + "static/media/pokemon.72236a08.png";